<template>
  <div id="statistic">
    <div class="ipub-filter-div mar-b-10">
      <template v-if="user.codeList&&user.codeList.includes('STATISTICS.DATA_REPORT.OTHER_REPORTS.INCOMPLETE_SUBMISSIONS_REPORT_DOWNLOAD')">
        <div class="ipub-filter-div-content mar-b-30">
          <div class="ipubw-h3">Authors</div>
          <div class="content-bg statistic-content-card  ipubw-p3 flex">
            <div>Incomplete Submissions Report</div>
            <ipub-tooltip placement="right"
                          type="dark"
                          class="mar-l-10 ">
              <div slot="title">
                <div><strong>The report contains:</strong></div>
                <ul style="line-height:20px">
                  <li>Journal</li>
                  <li>Manuscript Title</li>
                  <li>Author's Email</li>
                  <li>Author's Name</li>
                  <li> Author's Country / Region</li>
                  <li>Manuscript Step</li>
                </ul>

              </div>
              <ipub-icon class="ipub-cursor-pointer"
                         type="iconInfo" />
            </ipub-tooltip>
            <div class="mar-l-30 ">Update time: {{params.INCOMPLETE_SUBMISSION_REPORT || '- -'}}</div>
            <div class="mar-l-30 ">
              <ipub-tooltip class="tooltip-box-item"
                            placement="bottomLeft">
                <div slot="title">Download</div>
                <ipub-icon type="icona-ExportReviewcomments"
                           class="ipub-c-p border-right"
                           @click="exp('INCOMPLETE_SUBMISSION_REPORT')" />
              </ipub-tooltip>
            </div>
          </div>
        </div>
      </template>
      <template v-if="user.codeList&&user.codeList.includes('STATISTICS.DATA_REPORT.OTHER_REPORTS.ACADEMIC_EDITORS_PERFORMANCE_REPORT_DOWNLOAD')">
        <div class="ipub-filter-div-content mar-b-30">
          <div class="ipubw-h3">Academic Editors</div>
          <div class="content-bg statistic-content-card  ipubw-p3 flex">
            <div>Academic Editors Performance Report</div>

            <ipub-tooltip placement="right"
                          type="dark"
                          class="mar-l-10 ">
              <div slot="title">
                <div><strong>The report contains:</strong> </div>
                <ul style="line-height:20px">
                  <li>Academic Editor's Email </li>
                  <li>Academic Editor's Name </li>
                  <li>Related Journals</li>
                  <li>Manuscript ID </li>
                  <li> Invited Time </li>
                  <li>Decision-MakingTime </li>
                  <li>Review Status</li>
                  <li>Decision Type </li>
                  <li>Decision </li>
                  <li>Spend Day(s)</li>
                </ul>
              </div>
              <ipub-icon class="ipub-cursor-pointer"
                         type="iconInfo" />
            </ipub-tooltip>
            <div class="mar-l-30 ">Update time: {{params.ACADEMIC_EDITOR_PERFORMANCE_REPORT || '- -'}}</div>
            <div class="mar-l-30 ">
              <ipub-tooltip class="tooltip-box-item "
                            placement="bottomLeft">
                <div slot="title">Download</div>
                <ipub-icon type="icona-ExportReviewcomments"
                           class="ipub-c-p"
                           @click="exp('ACADEMIC_EDITOR_PERFORMANCE_REPORT')" />
              </ipub-tooltip>

            </div>
          </div>
        </div>
      </template>
      <template v-if="user.codeList&&user.codeList.includes('STATISTICS.DATA_REPORT.OTHER_REPORTS.ARTICLE_KEYWORDS_REPORT_DOWNLOAD')">
        <div class="ipub-filter-div-content mar-b-30">
          <div class="ipubw-h3">Articles</div>
          <div class="content-bg statistic-content-card  ipubw-p3 flex">
            <div>Article Keywords Report</div>
            <ipub-tooltip placement="right"
                          type="dark"
                          class="mar-l-10 ">
              <div slot="title">
                <div><strong>The report contains:</strong></div>
                <ul style="line-height:20px">
                  <li>Journal</li>
                  <li>Manuscript No. </li>
                  <li>Volume </li>
                  <li>Issue </li>
                  <li> DOI </li>
                  <li>Keywords </li>
                </ul>
              </div>
              <ipub-icon class="ipub-cursor-pointer"
                         type="iconInfo" />
            </ipub-tooltip>
            <div class="mar-l-30 ">Update time: {{params.ARTICLE_KEYWORDS_REPORT || '- -'}}</div>
            <div class="mar-l-30 ">
              <ipub-tooltip class="tooltip-box-item"
                            placement="bottomLeft">
                <div slot="title">Download</div>
                <ipub-icon type="icona-ExportReviewcomments"
                           class="ipub-c-p"
                           @click="exp('ARTICLE_KEYWORDS_REPORT')" />
              </ipub-tooltip>

            </div>
          </div>
        </div>
      </template>
      <template v-if="user.codeList&&user.codeList.includes('STATISTICS.DATA_REPORT.OTHER_REPORTS.REVIEWERS_REVIEW_RECORD_REPORT_DOWNLOAD')">
        <div class="ipub-filter-div-content mar-b-30">
          <div class="ipubw-h3">Reviewers</div>
          <div class="content-bg statistic-content-card  ipubw-p3 flex mar-b-4">
            <div>Reviewers Review Record Report</div>
            <ipub-tooltip placement="right"
                          type="dark"
                          class="mar-l-10 ">
              <div slot="title">
                <div><strong>The report contains:</strong></div>
                <ul style="line-height:20px">
                  <li>Journal</li>
                  <li>Manuscript No.</li>
                  <li>Manuscript Status </li>
                  <li>Reviewer's Email</li>
                  <li>Reviewer's Name </li>
                  <li>Review Status</li>
                  <li>Reviewer's Recommendation</li>
                  <li>Comments to Author </li>
                  <li>Comments to Editor </li>
                  <li>Manuscript Version </li>
                  <li>Invited Time </li>
                  <li>Agreed Time </li>
                  <li>Decision-MakingTime</li>
                  <li> Spend Day(s) </li>
                  <li>Review Rating </li>
                  <li>Voucher Value</li>
                  <li>Suggest Own References</li>
                </ul>
              </div>
              <ipub-icon class="ipub-cursor-pointer"
                         type="iconInfo" />
            </ipub-tooltip>
            <div class="mar-l-30 ">Update time: {{params.REVIEWERS_REVIEW_RECORD_REPORT || '- -'}}</div>
            <div class="mar-l-30 ">
              <ipub-tooltip class="tooltip-box-item"
                            placement="bottomLeft">
                <div slot="title">Download</div>
                <ipub-icon type="icona-ExportReviewcomments"
                           class="ipub-c-p"
                           @click="exp('REVIEWERS_REVIEW_RECORD_REPORT')" />
              </ipub-tooltip>

            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>